<!-- <div class="inner-splash" [class.has-header-bar]="!inIframe"
[class.hidden1]="(viewModelLoaded && !orchestratorViewModel.actionInProgress) || orchestratorViewModel.documentEnabled">
</div> -->
<div class="inner-splash" [class.has-header-bar]="skipHeader" [class.hidden]="!isVisible"></div>
@if (animation || text?.length > 0) {
  <div class="loader-content" [class.hidden]="!isVisible">
    @if (animation) {
      <div class="loader-animation"></div>
    }
    @if (text?.length > 0) {
      <div class="loader-text" [class.has-loader-animation]="animation">{{text}}</div>
    }
  </div>
}